export enum Section {
  Assigned = 'Assigned to Me',
  Urgent = 'Urgent Patient Reports',
  NonUrgent = 'Other Patient Reports',
  Overdue = 'Overdue Reports',
  Callback = 'Tickets & Callback Requests',
  TasksDue = 'Tasks Due',
  ResolvedItems = 'Resolved Items'
}
